import autosize from "../../../../vendor/assets/javascripts/limitless_kit/plugins/forms/inputs/autosize.min";

globalThis.autosize = autosize;
